"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityApi = void 0;
var tslib_1 = require("tslib");
var qs_1 = tslib_1.__importDefault(require("qs"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var social_content_1 = require("../social-content");
var http_1 = require("@wix/ambassador-social-groups-v1-activity-stats/http");
var BaseApi_1 = require("../BaseApi");
/**
 * ActivityApi - client for groups activity api
 * https://github.com/wix-private/catalyst-server/tree/master/social-content/social-content-api/src/main/proto/wix/social
 *
 */
var ActivityApi = /** @class */ (function (_super) {
    tslib_1.__extends(ActivityApi, _super);
    function ActivityApi(token, apiUrl, context) {
        var _this = _super.call(this, context) || this;
        _this.token = token;
        _this.axios = axios_1.default.create({
            baseURL: '/social-content/api/v1',
            headers: {
                Authorization: token,
            },
            paramsSerializer: function (params) {
                return qs_1.default.stringify(params, {
                    encode: false,
                    allowDots: true,
                    arrayFormat: 'repeat',
                });
            },
        });
        _this.tokenService = new social_content_1.ContextTokenService(context);
        return _this;
    }
    ActivityApi.prototype.getActivities = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_1.getActivityStats({ groupId: groupId }))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ActivityApi.prototype.getGroupContextToken = function (groupId) {
        return this.tokenService.getContextToken(groupId);
    };
    ActivityApi.prototype.getLatestActivities = function (groupIds, query) {
        if (query === void 0) { query = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = query;
                        return [4 /*yield*/, this.tokenService.getContextTokens(groupIds)];
                    case 1:
                        _a.contextTokens = _b.sent();
                        query.activityTypes = ['wix.feed.activities.PostedInFeed'];
                        return [2 /*return*/, this.axios.post("/activities/latest/query", query)];
                }
            });
        });
    };
    return ActivityApi;
}(BaseApi_1.BaseApi));
exports.ActivityApi = ActivityApi;
//# sourceMappingURL=ActivityApi.js.map